module.exports = __webpack_public_path__ + "static/logoblue-238847b0c45b835781df5f559028c9e9.png";